<template>
	<div class="w-100">
	<div class="product--buying-options d-flex justify-content-between" v-if="pagecategory">
	
	
		<span v-if="$root.customer_info.role==3" class="w-100">
			<b-button type="button" class="btn--product btn--product-add-to-cart shareProduct"   @click="$root.updateShareshop(productData),$root.sharepopup()" >Share Product</b-button>
		
		</span>
		<span v-else class="w-100">
			<b-button v-if="productData.product_type==2 && productData.product_slug==null " type="button" class="btn--product btn--product-add-to-cart viewProduct"  :href="'/product/'+productData.product_id"  >View Product</b-button>
			<b-button v-if="productData.product_type==2 && productData.product_slug!=null " type="button" class="btn--product btn--product-add-to-cart  viewProduct"  :href="'/'+productData.product_slug"  >View Product</b-button>
			
			
			<b-button v-if="productData.product_type==1 && productData.stock_qty > 0" type="button" class="btn--product btn--product-add-to-cart AddToCart" @click="$root.updateCart(productData,1)" >Add to Bag</b-button>
			
			<b-button v-if="productData.product_type!=2 && productData.stock_qty== 0 && productData.product_slug==null" type="button" class="btn--product btn--product-add-to-cart AddToCart" :href="'/product/'+productData.product_id" >Sold Out</b-button>
			<b-button v-if="productData.product_type!=2 && productData.stock_qty== 0 && productData.product_slug!=null" type="button" class="btn--product btn--product-add-to-cart AddToCart" :href="'/'+productData.product_slug" >Sold Out</b-button>
			
			
			
		
		</span>
	
		 
		<div class="addtofavouritebtn">
		<a v-if="$root.customer_info.access_key!=''" 
		  @click="$root.addtofavourite(productData)"
		  :class="[productData.heart == 1 ?  'btn--product btn--product-add-to-favourites-heart' : 'btn--product btn--product-add-to-favourites-heart-fill', '']">
		  <b-icon icon="heart" :class="[productData.heart == 1 ?'heart':'heart-fill']"  v-b-tooltip.hover title="Add to Wishlist" placement="bottom" ></b-icon>
		</a>
		<a v-else @click="addtofavouriteNotlogin()"
		  :class="[productData.heart == 1 ?  'btn--product btn--product-add-to-favourites-heart' : 'btn--product btn--product-add-to-favourites-heart-fill', '']">
		  <b-icon icon="heart" :class="[productData.heart == 1 ?'heart':'heart-fill']"  v-b-tooltip.hover title="Add to Wishlist" placement="bottom" ></b-icon>
		</a>
	  </div> 
	  <!--<div v-if="$root.customer_info.role==3">		
			<a  v-if="productData.inshop==1" class="inshopcart" :class="[productData.inshop == 1 ?  'btn--product btn--product-add-to-favourites-heart' : 'btn--product btn--product-add-to-favourites-heart-fill', '']">
		  <b-icon icon="bag" aria-hidden="true" :class="[productData.inshop == 1 ?'inshop':'']" v-b-tooltip.hover title="Already added in your Shop!" placement="bottom" ></b-icon>
		  </a>	
		<a  v-else @click="$root.updateShare(productData),productData.inshop=1" class="inshopcart" :class="[productData.inshop == 1 ?  'btn--product btn--product-add-to-favourites-heart' : 'btn--product btn--product-add-to-favourites-heart-fill', '']">
		  <b-icon icon="bag" aria-hidden="true" :class="[productData.inshop == 1 ?'inshop':'']" v-b-tooltip.hover title="Add to Shop" placement="bottom" ></b-icon>
		  </a>	
	  </div> -->
	</div>
	<span v-if="pagequickview">
		<b-link v-if="productData.product_type==2" class="btn-solid btn2 viewproduct" :href="'/product/'+productData.product_id">View Product</b-link>
		<b-link v-else class="btn-solid btn2" @click="$root.updateCart(productData,cartQty); $bvModal.hide('qv-modal')">Add To Cart</b-link>
	</span>
	<span v-if="productview">
	 <b-button type="button" variant="secondary" class="related-product--add-cart-cta d-block AddToCart" @click="$root.updateCart(productData,1)">Add to Bag</b-button>
	 </span>
	
	
	</div>
</template>
<script>

export default {
  name: 'AddtocartButton',
  props: {
    productData: { type: Object },
	pagecategory:Boolean,
	pagequickview:Boolean,
	cartQty:Number,
	productview:Boolean,
  },
  mounted(){
  //this.inLodcard;
  },
  computed: {
    //
  },
  data() {
    return{
      //modaldata_qty: 1,
	  //variant:'dark',
	  //cartHeader:'',
        //{{$root.cart.quantity}}
    }
  },
  methods:{
		addtofavouriteNotlogin(){
			if(this.$root.customer_info.access_key == ''){
				this.$router.push({
					name: 'Login',
					params: {
						redirect: '/category/'+this.$route.params.category
					}
				});
			}
		}
	/* inLodcard(){
	this.cartHeader ='
	} */
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style   scoped lang="scss">
	
</style>
